export default __webpack_public_path__ + "static/media/locationicon.dcb5120f.svg";